<template>



    <div class="tab-pane active" id="base-justified-details" role="tabpanel">
        <div class="mb-1 card-body">
            <div class="two-header">
                <div class="d-flex justify-content-between align-items-center has-line">
                    <h5 class="card-title mb-0">Customer</h5>
                    <a href="#" class="rtn-edit" data-toggle="modal" data-target="#editConsumerModal"><i class="ri-edit-fill me-1"></i> Edit</a>
                </div>
            </div>
            <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">

            
            
                <router-link
                        :to="{
                            name: 'customerDetails',
                            params: { id: order.customer.id },
                        }"
                        target="_blank"
                        title="Details Customer"
                        >{{ order.customer.company_name }}</router-link
                    >
                <br>
                <template v-if="order.customer.customer_contacts.length">
                    <template v-if="order.customer.customer_contacts[0]
                                .contact_name != ''">
                        {{
                            order.customer.customer_contacts.length
                                ? order.customer.customer_contacts[0]
                                    .contact_name
                                : ""
                        }}<br>
                    </template>
                    
                </template>
                
                <template v-if="order.customer.customer_contacts.length">
                    <template v-if="order.customer.customer_contacts[0]
                                .email != ''">
                        {{
                            order.customer.customer_contacts.length
                                ? order.customer.customer_contacts[0]
                                    .email
                                : ""
                        }}<br>
                    </template>
                    
                </template>

                <template v-if="order.customer.customer_contacts.length">
                    <template v-if="order.customer.customer_contacts[0]
                                .contact_no != ''">
                        {{
                            order.customer.customer_contacts.length
                                ? order.customer.customer_contacts[0]
                                    .contact_no
                                : ""
                        }}<br>
                    </template>
                    
                </template>
                        <template v-if="order.customer.customer_contacts.length == 0">
                    {{ order.customer.address }}
                
                </template>  
                

            </div>
        </div>
        <hr class="mt-0 mb-2">
        <div class="mb-1 card-body">
            <div class="two-header">
                <div class="d-flex justify-content-between align-items-center has-line">
                    <h5 class="card-title mb-0">Ship To</h5>
                    <a href="#" class="rtn-edit" data-toggle="modal" data-target="#editShipToModal"><i class="ri-edit-fill me-1"></i> Edit</a>
                </div>
            </div>
            

                <template v-if="order.is_stocking" >
                    <template v-if="order.warehouses">
                    <template v-for="(item, index) in order.warehouses">
                    
                    <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                    
                    <div  v-html="formatDescription(item.address)"></div>
                        <!-- <template v-if="item.warehouse">
                            <template v-if="item.warehouse.address2 != null">
                                {{ item.warehouse.address2 }} <br>
                            </template>
                            <template v-if="item.warehouse.address != null">
                                {{ item.warehouse.address }} <br>
                            </template>

                            <template v-if="item.warehouse.city != null">
                                {{ item.warehouse.city }} 
                            </template>

                            <template v-if="item.warehouse.state != null">
                                {{ item.warehouse.state }} 
                            </template>

                            

                            <template v-if="item.warehouse.post_code != null">
                                {{ item.warehouse.post_code }} 
                            </template>
                            
                            
                        </template>
                        <template v-else>
                            {{ item.address }}
                        </template> -->
                        </div>
                    </template>
                
                </template>
                
                </template>

                
            
        </div>
        <hr class="mt-0 mb-2">
        <div class="mb-1 card-body">
            <div class="two-header">
                <div class="d-flex justify-content-between align-items-center has-line">
                    <h5 class="card-title mb-01">Customer Delivery Address</h5>
                </div>
            </div>

            <template
                v-if="
                    order.customer_warehouses &&
                    order.customer_warehouses.length 
                    
                "
            >

            <template  v-for="(
                    item, index
                ) in order.customer_warehouses">
                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                <div  v-html="formatDescription(item.address)"></div>
               
                <!-- <template v-if="item.warehouse">

                            <template v-if="item.warehouse.address2 != null">
                                {{ item.warehouse.address2 }} <br>
                            </template>
                            <template v-if="item.warehouse.address != null">
                                {{ item.warehouse.address }} <br>
                            </template>

                            <template v-if="item.warehouse.city != null">
                                {{ item.warehouse.city }} 
                            </template>

                            <template v-if="item.warehouse.state != null">
                                {{ item.warehouse.state }} 
                            </template>

                            

                            <template v-if="item.warehouse.post_code != null">
                                {{ item.warehouse.post_code }} 
                            </template>
                            
                            
                        </template>
                        <template v-else>
                            {{ item.address }}
                        </template> -->
                </div>
                

            </template>
            


            </template>
            
        </div>
        <template v-if="order.is_stocking">
            <hr class="mt-0 mb-2">
            <div class="mb-3 card-body">
                <div class="two-header">
                <div class="d-flex justify-content-between align-items-center has-line">
                        <h5 class="card-title mb-01">Stocking Terms</h5>
                </div>
                </div>
                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                    <div class="text-muted text-center">{{ order.stocking_terms }}</div>
                </div>
            </div>
        </template>
                                            


                                            <!-- Edit Consumer Modal -->
                <div class="modal fade" id="editConsumerModal" tabindex="-1" aria-labelledby="editConsumerModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editConsumerModalLabel">Edit Customer</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body form-steps">

                            <v-select
                        label="text"
                        :filterable="false"
                        v-model="customerForm.customer"
                        :options="customers"
                        @search="onCustomerSearch"
                        @input="onCustomerSelect"
                        @selected="onCustomerSelect"
                        @deselected="onCustomerDeSelect"
                    >
                        <template slot="no-options">
                            type to search customers..
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center" v-html="option.html"></div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div
                                class="selected d-center"
                                v-html="option.text"
                            ></div>
                        </template>
                    </v-select>

                               

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md" v-on:click="saveCustomerData">Save</button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Customer Modal -->

                <!-- Edit Ship To Modal -->
                <div class="modal fade" id="editShipToModal" tabindex="-1" aria-labelledby="editShipToModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editShipToModalLabel">Edit Ship To</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                            </div>
                            <div class="modal-body px-0 py-1 form-steps">
                                <div class="hov-sec">
                                    <label>Stocking?</label>
                                    <div class="d-flex">
                                        <div class="form-check me-2">
                                        <input
                                            type="radio"
                                            class="form-check-input radio-ship-yes"
                                            name="is_stocking"
                                            value="1"
                                            v-model="shippingForm.is_stocking"
                                        />

                                            
                                            <label class="form-check-label" for="flex1">
                                                Yes
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                type="radio"
                                                class="form-check-input radio-ship-no"
                                                name="is_stocking"
                                                value="0"
                                                v-model="shippingForm.is_stocking"
                                            />

                                            
                                            <label class="form-check-label" for="flex2">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="ship-no hov-sec" v-if="shippingForm.is_stocking == 1">
                                    <label>Stocking Terms</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        v-model="shippingForm.stocking_terms"
                                    />
                                    
                                </div>

                                
                        
                                <div class="ship-no hov-sec" v-if="shippingForm.is_stocking == 1">
                                    <div id="sw"></div>
                                    <div class="" v-for="(warehouse, index) in shippingForm.warehouses">
                                        <!-- <template v-if="shippingForm.warehouses[index].address !=  null"> -->
                                            <label>Superb Warehouse</label>
                                            <div class="popup-rown">
                                                <v-select :filter="fuseSearchSuperb" label="address" 
                                                    
                                                    @input="(value) => warehouseChange(value, 'warehouses', index)"

                                                    placeholder="Select Superb Warehouse"    
                                                    v-model="shippingForm.warehouses[index].warehouse_id" 
                                                    :filterable="true" 
                                                    :options="companyWarehouse" :reduce="(option) => option.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.name }}
                                                            
                                                        </div>
                                                    <!-- <template v-if="option.warehouse != null">
                                                        <div class="d-center">
                                                            {{ option.address }}
                                                        </div>
                                                    </template> -->
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <!-- <template v-if="option.warehouse != null">
                                                        <div class="selected d-center">
                                                            {{ option.warehouse.address }}
                                                        </div>
                                                    </template> -->
                                                    <div class="selected d-center">
                                                            {{ option.name }}
                                                            <!-- {{ option.state }} 
                                                                {{ option.city }}  -->
                                                        </div>
                                                    </template>
                                                </v-select>


                                                
                                                <a
                                                    href="javascript:void(0);"
                                                    @click="
                                                        removeWarehouse(
                                                            warehouse,
                                                            index
                                                        )
                                                    "
                                                    v-if="
                                                        shippingForm.warehouses.length >
                                                        1
                                                    "
                                                    class="btn btn-danger px-3 py-2"
                                                    >Remove</a
                                                >
                                                </div>
                                                
                                                <textarea 
                                                    class="form-control append-edit-address mt-2"
                                                    placeholder=""
                                                    v-model="
                                                        shippingForm.warehouses[index].address
                                                    "
                                                ></textarea>
                                            
                                        <!-- </template> -->
                                        </div>
                                    <div class="mt-2 text-end" v-if="shippingForm.warehouses.length < maxNumOfShipToAddress">
                                        <a
                                            @click="addWarehouse()"
                                            href="javascript:void(0);"
                                            class="btn btn-info add-sw"
                                        >Add</a>
                                        
                                    </div>
                                </div>
                                <div class="hov-sec">
                                    <div id="cw"></div>
                                    <div class=""  v-for="(
                                            warehouse, index
                                        ) in shippingForm.customerWarehouses">
                                        <label>Customer Warehouse</label>
                                        <!-- <v-select v-model="shippingForm.customerWarehouses[index].warehouse_id"
                                        @input="changeRoute($event,index)"
                                         :options="customerWarehouse"
                                         :reduce="(option) => option.warehouse.id" 
                                         :filterable="true" 
                                         label="address" /> -->

                                        <div class="popup-rown">
                                        <v-select :filter="fuseSearch" @search="fetchOptions" 
                                        @input="(value) => warehouseChange(value, 'customerWarehouses', index)"
                                          label="name"   placeholder="Select Customer Warehouse"    
                                                    v-model="shippingForm.customerWarehouses[index].warehouse_id" 
                                                    :filterable="true" 
                                                    :options="customerWarehouse" :reduce="(option) => option.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">

                                                    <div class="d-center" >{{ option.name }}</div>
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    
                                                    <div class="selected d-center">{{ option.name }}</div> 
                                                    
                                                    </template>
                                                    
                                                </v-select>
                                        

                                        

                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeCustomerWarehouse(
                                                    warehouse,
                                                    index
                                                )
                                            "
                                            v-if="
                                                shippingForm.customerWarehouses
                                                    .length > 1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                        </div>

                                        <textarea 
                                    class="form-control append-edit-address mt-2"
                                    placeholder=""
                                    v-model="
                                        shippingForm.customerWarehouses[index]
                                            .address
                                    "
                                ></textarea>
                                        
                                        
                                    </div>
                                    <div class="mt-2 text-end" v-if="
                                    shippingForm.customerWarehouses.length <
                                    maxNumOfShipToAddress
                                ">
                                 <a
                                    @click="addCustomerWarehouse()"
                                    href="javascript:void(0);"
                                    class="btn btn-info add-cw"
                                    >Add</a
                                >

                                        
                                    </div>
                                </div>
                                <div class="hov-sec">
                                    <div id="bt"></div>
                                    <div class="" v-for="(
                                    warehouse, index
                                ) in shippingForm.billTo">
                                        <label>Bill To</label>
                                        <template v-if="warehouse.warehouse">
                                        <v-select label="address"   placeholder="Select Bill To"    
                                                    v-model=" shippingForm.billTo[index].warehouse_id" 
                                                    :filterable="true" 
                                                    :options="shippingForm.billTo" :reduce="(option) => option.warehouse.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">

                                                    <template v-if="option.warehouse != null">
                                                        <div class="d-center">
                                                            {{ option.warehouse.address }}
                                                        </div>
                                                    </template>
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <template v-if="option.warehouse != null">
                                                        <div class="selected d-center">
                                                            {{ option.warehouse.address }}
                                                        </div>
                                                    </template>
                                                    
                                                    </template>
                                                </v-select>
                                            </template>
                                        <!-- <select
                                            name="cars"
                                            class="custom-select"
                                            v-model="
                                                shippingForm.billTo[index]
                                                    .warehouse_id
                                            "
                                        >
                                            <option
                                                v-for="item in customerWarehouses"
                                                :value="item.id"
                                            >
                                                {{ item.address }}
                                            </option>
                                        </select> -->
                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeBillTo(warehouse, index)
                                            "
                                            v-if="
                                                shippingForm.billTo.length > 1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                        <textarea
                                        class="form-control append-edit-address mt-2"
                                        placeholder=""
                                        v-model="shippingForm.billTo[index].address"
                                    ></textarea>
                                        
                                    </div>
                                    
                                    <div class="mt-2 text-end" v-if="
                                    shippingForm.billTo.length <
                                    maxNumOfShipToAddress
                                ">
                                         <a
                                            @click="addBillTo()"
                                            href="javascript:void(0);"
                                            class="btn btn-info add-bt"
                                            >Add</a
                                        >
                                        <!-- <button class="btn btn-info add-bt">Add</button> -->
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer border-top py-2">
                                <a
                                    href="javascript:void(0);"
                                   
                                    :disabled="loading"
                                    @click="saveShippingData"
                                    class="btn btn-primary w-md"
                                    >Save</a
                                >

                                <!-- <button class="btn btn-primary w-md">Submit</button> -->
                                <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Ship To Modal -->

                                        </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapState } from "vuex";
import Vue from "vue";
import AddWarehouse from "./AddWarehouse";
import Fuse from 'fuse.js';
export default {
    name: "OrderCustomer",
    props: ["order", "loading","companyWarehouse"],
    components: {
        AddWarehouse,
    },
    mounted() {
        this.getCustomerWarehouse();
        this.syncLatestData();
        console.log("mounted Order : ", this.order);
    },
    data() {
        return {
            customerWarehouse:[],
            editCustomer: false,
            editShipping: false,
            customerForm: {
                customer: null,
                customer_id: null,
            },
            customers: [],
            customerData: null,
            shipSearch: null,
            shippingForm: {
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [{
                    id: null,
                    warehouse_id: null,
                    address: null,
                }],
                customerWarehouses: [],
                billTo: [],
            },
            warehouses: [],
            customerWarehouses: [],

            showWarehouse: false,
            warehouseAddType: null,
            warehouseAddIndex: null,
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        changeSuperbData(value,index){
            console.log("this.shippingForm.warehouses",this.shippingForm.warehouses)

            shippingForm.warehouses

            // let carriers = this.companyWarehouse.filter(
            //              (x) => x.id == value
            //          );

            // if(carriers.length > 0){
            //     // let idChange = x.id + Math.floor(Math.random() * 100)
            //     // xData = Object.assign(xData, {warehouse: {id:idChange,address:x.address,custom:1}});
            //     if(this.shippingForm.warehouses[index].select_warehouse){
            //         console.log("select_warehouse exists");
            //         this.shippingForm.warehouses[index].select_warehouse = carriers[0];
            //     }
            //     else{
            //         this.shippingForm.warehouses[index].select_warehouse = carriers[0];
            //         console.log("select_warehouse not exists");
            //     }
            //     this.shippingForm.warehouses[index].address = carriers[0].address
            // }
            
            
            
            // console.log("dddddddd",value);
            // console.log("dddddddd index",index);
        },
        fetchOptions(search, loading){
            console.log("serach",search);
        },
        fuseSearchSuperb(options, search) {
            const fuse = new Fuse(options, {
                keys: ['address2', 'address', 'state','city'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ['address2', 'warehouse.address', 'warehouse.state','warehouse.city','state','city'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        getCustomerWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.customer", {customer_id:this.order.customer_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        console.log("fff",data.data)
                        this.customerWarehouse = data.data;
                        
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        warehouseModalClosedEvent() {
            this.showWarehouse = false;
            this.warehouseAddIndex = null;
            this.warehouseAddType = null;
        },
        warehouseAddedEvent(warehouse) {
            if (
                this.warehouseAddType == "billTo" ||
                this.warehouseAddType == "customerWarehouses"
            ) {
                this.customerWarehouses.push(warehouse);
            } else {
                this.customerWarehouses.push(warehouse);
            }

            let address = warehouse.name+ '\n';
                address += warehouse.address+ '\n';
           
            
             if (warehouse.city) {
                address += `${warehouse.city}`;
            }
            if (warehouse.state) {
                address += ` ${warehouse.state}`;
            }
            if (warehouse.post_code) {
                address += ` ${warehouse.post_code}`;
            }

            this.shippingForm[this.warehouseAddType][
                this.warehouseAddIndex
            ].warehouse_id = warehouse.id;

            this.shippingForm[this.warehouseAddType][
                this.warehouseAddIndex
            ].address = address;

            setTimeout(() => {
                this.showWarehouse = false;
                this.warehouseAddIndex = null;
                this.warehouseAddType = null;
                $("#addWarehouseModal").modal("hide");
            }, 5000);
        },
        warehouseChange(event, type, index) {
            //alert("sss"+event);
            if (event == "add_new") {
                this.showWarehouse = true;
                this.warehouseAddType = type;
                this.warehouseAddIndex = index;
                this.shippingForm[type][index].warehouse_id = null;
                //$('#addWarehouseModal').modal('show');
                setTimeout(() => {
                    $("#addWarehouseModal").modal("show");
                }, 100);
            } else {
                let warehouse = null;
                if (
                    type == "billTo" ||
                    type == "customerWarehouses"
                ) {
                    warehouse = this.customerWarehouse.find(
                        (x) => (x.id == event)
                    );
                } else {
                    warehouse = this.companyWarehouse.find(
                        (x) => (x.id == event)
                    );
                }

                console.log("warehouse",warehouse);
                if (warehouse) {
                     let address = warehouse.name+ '\n';
                     address += warehouse.address+ '\n';
                    
                   
                    if (warehouse.city) {
                        address += ' '+`${warehouse.city}`;
                    }
                     if (warehouse.state) {
                        address += ` ${warehouse.state}`;
                    }
                    if (warehouse.post_code) {
                        address += ' '+`${warehouse.post_code}`;
                    }

                    this.shippingForm[type][index].address = address;
                    console.log("this.shippingForm[type][index].address",this.shippingForm[type][index].address);
                }
            }
        },
        addWarehouse() {
            this.shippingForm.warehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "superb");
            } else {
                this.shippingForm.warehouses.splice(index, 1);
            }
        },
        addCustomerWarehouse() {
            this.shippingForm.customerWarehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeCustomerWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer");
            } else {
                this.shippingForm.customerWarehouses.splice(index, 1);
            }
        },
        addBillTo() {
            this.shippingForm.billTo.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeBillTo(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer", true);
            } else {
                this.shippingForm.billTo.splice(index, 1);
            }
        },
        editCustomerClick() {
            this.editCustomer = true;
            this.editShipping = true;
            this.getWarehouses(0);
            this.getWarehouses(1);
            this.$emit("editCustomerClickEvent");
        },
        saveCustomerData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("so.updateOrderCustomerData", {
                        id: this.order.id,
                    }),
                    this.customerForm,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.$emit("updatedCustomerEvent");
                        self.editCustomer = false;
                        /*self.customerForm = {
                            customer: null,
                            customer_id: null,
                        };*/
                        $('#editConsumerModal').modal('hide');
                        self.setSuccessMessage("Order saved successfully");
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getCustomerDetail(customer_id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("searchCustomerDetails"),
                    { customer_id: customer_id },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.customerData = data.data.customer_data;
                        if (data.data.customer_data.sales_rep_id) {
                            this.customerForm.sale_rep =
                                data.data.customer_data.sales_rep_id;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        onCustomerSelect(event) {
            if (event) {
                this.customerForm.customer_id = event.id;
            } else {
                this.customerForm.customer_id = null;
            }
        },
        onCustomerDeSelect(event) {
            this.customerForm.customer_id = null;
        },
        onCustomerSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios
                .post(
                    window.route("searchCustomer"),
                    { searchTerm: search, contactType: 1 },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {})
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        getWarehouses(is_customer = 0) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let url = window.route("getWarehouses");
            if (is_customer) {
                if (this.order.customer) {
                    url = window.route("getWarehouses", {
                        customer_id: this.order.customer.id,
                    });
                } else {
                    return;
                }
            }
            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (is_customer) {
                            this.customerWarehouses = data.data;
                            let defaultWarehouses =
                                this.customerWarehouses.filter(
                                    (x) => x.is_default
                                );
                            if (
                                defaultWarehouses.length &&
                                (this.shippingForm.customerWarehouses[0]
                                    .address == null ||
                                    this.shippingForm.customerWarehouses[0]
                                        .address == "") &&
                                this.shippingForm.customerWarehouses[0]
                                    .warehouse_id == null
                            ) {
                                this.shippingForm.customerWarehouses[0].warehouse_id =
                                    defaultWarehouses[0].id;
                            }
                        } else {
                            this.warehouses = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        saveShippingData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("so.updateOrderShippingData", {
                        id: this.order.id,
                    }),
                    this.shippingForm,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        $('#editShipToModalLabel').modal("hide");
                        $('#editShipToModal').modal("hide");
                        self.$emit("updatedShippingEvent");
                        self.editShipping = false;
                        /*self.customerForm = {
                            customer: null,
                            customer_id: null,
                        };*/
                        self.setSuccessMessage("Order saved successfully");
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        deleteWarehouse(id, type = "customer", isBill = false) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("orders.warehouses.destroy", {
                                    id: self.order.id,
                                    warehouse_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.$emit("updatedShippingEvent");
                                    self.setSuccessMessage(
                                        "Warehouse deleted from order!"
                                    );
                                    if (type === "customer") {
                                        if (isBill) {
                                            self.order.products.splice(
                                                self.shippingForm.billTo.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        } else {
                                            self.order.products.splice(
                                                self.shippingForm.customerWarehouses.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        }
                                    } else {
                                        self.order.products.splice(
                                            self.shippingForm.warehouses.indexOf(
                                                (x) => x.id == id
                                            ),
                                            1
                                        );
                                    }
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        syncLatestData() {
            if (this.order.customer) {
                this.customerForm.customer_id = this.order.customer_id;

                let html =
                    "<div>" + this.order.customer.company_name + "</div>";
                if (this.order.customer.customer_contacts.length) {
                    html =
                        "<div>" +
                        this.order.customer.customer_contacts[0].contact_name +
                        "</div>" +
                        '<div class="short_text">Company:' +
                        this.order.customer.company_name +
                        "</div>";
                }
                this.customerForm.customer = {
                    id: this.order.customer.id,
                    sales_rep_id: this.order.customer.sales_rep_id,
                    text: "<div>" + this.order.customer.company_name + "</div>",
                    name: "<div>" + this.order.customer.company_name + "</div>",
                    html: html,
                };
            }

            this.shippingForm.is_stocking = this.order.is_stocking;
            this.shippingForm.stocking_terms = this.order.stocking_terms;
            if(this.order.warehouses.length > 0){
                this.shippingForm.warehouses = _.cloneDeep(this.order.warehouses);
            }
            
            this.shippingForm.customerWarehouses = _.cloneDeep(
                this.order.customer_warehouses
            );
            console.log('this.shippingForm.warehouses 4444444444444',this.shippingForm.warehouses);
            // this.shippingForm.customerWarehouses = _.cloneDeep(this.order.customer_warehouses).map(wh => {
            //     const name = wh.warehouse?.name || '';
            //     const street = wh.warehouse?.address || '';
            //     let city = wh.warehouse?.state || '';
            //          city += ", "+wh.warehouse?.city || '';
            //          city += ", "+wh.warehouse?.post_code || '';

            //     const formattedAddress = [name,street, city]
            //         .filter(Boolean) // remove empty fields
            //         .join('\n ');     // join them into one line

            //     return {
            //         ...wh,
            //         address: formattedAddress
            //     };
            //     });

            //     console.log("this.shippingForm.customerWarehouses",this.shippingForm.customerWarehouses);
            this.shippingForm.billTo = _.cloneDeep(this.order.bill_warehouses);

            if (
                this.order.customer_warehouses &&
                this.order.customer_warehouses.length == 0
            ) {
                this.shippingForm.customerWarehouses = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                    },
                ];
            }

            if (
                this.order.bill_warehouses &&
                this.order.bill_warehouses.length == 0
            ) {
                this.shippingForm.billTo = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                    },
                ];
            }
        },
        formatDescription(desc) {
        if (!desc) return '';
        return desc.replace(/\n/g, '<br>');
        },
    },
    computed: {
        ...mapState(["salesOrderState"]),
        ...mapGetters(["maxNumOfShipToAddress"]),
    },
    watch: {
        "shippingForm.is_stocking": {
            handler: function (after, before) {
                if (after == 1) {
                    // console.log("ddd");
                    // this.shippingForm.warehouses = [
                    //     {
                    //         id: null,
                    //         warehouse_id: null,
                    //         address: null,
                    //     },
                    // ];

                    // if (this.warehouses.length) {
                    //     let defaultWarehouses = this.warehouses.filter(
                    //         (x) => x.is_default
                    //     );
                    //     if (defaultWarehouses.length) {
                    //         this.shippingForm.warehouses[0].warehouse_id =
                    //             defaultWarehouses[0].id;
                    //     }
                    // }
                } else {
                    this.shippingForm.warehouses = [];
                }
            },
        },
        order: {
            handler: function (after, before) {
                this.syncLatestData();
            },
        },
    },
};
</script>

<style scoped></style>
